// extracted by mini-css-extract-plugin
export default {"Arrow":"CarouselArrow_Arrow__kVTXR","RightArrow":"CarouselArrow_RightArrow__vA953","IsTabletArrowNotVisible":"CarouselArrow_IsTabletArrowNotVisible__juUHs"};